import { __decorate } from "tslib";
import React from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import isString from 'lodash/isString';
import noop from 'lodash/noop';
import C7NRate from 'choerodon-ui/lib/rate';
import { Tooltip as TextTooltip } from '../core/enum';
import { FIELD_SUFFIX } from '../form/utils';
import { FormField } from '../field/FormField';
import { renderValidationMessage } from '../field/utils';
import Icon from '../icon';
import { LabelLayout, ShowValidation } from '../form/enum';
import autobind from '../_util/autobind';
import { hide, show } from '../tooltip/singleton';
let Rate = class Rate extends FormField {
    constructor() {
        super(...arguments);
        this.onChange = (value) => {
            this.setValue(value);
        };
    }
    get hasFloatLabel() {
        const { labelLayout } = this;
        if (labelLayout) {
            return [LabelLayout.float, LabelLayout.placeholder].includes(labelLayout);
        }
        return false;
    }
    renderValidationResult(validationResult) {
        const validationMessage = this.getValidationMessage(validationResult);
        const { labelLayout, showValidation, getProPrefixCls } = this.context;
        if (validationMessage) {
            const showIcon = !((labelLayout && [LabelLayout.float, LabelLayout.placeholder].includes(labelLayout)) || showValidation === ShowValidation.newLine);
            return renderValidationMessage(validationMessage, showIcon, getProPrefixCls);
        }
    }
    handleHelpMouseEnter(e) {
        const { getTooltipTheme, getTooltipPlacement } = this.context;
        show(e.currentTarget, {
            title: this.getDisplayProp('help'),
            popupClassName: `${this.getContextConfig('proPrefixCls')}-tooltip-popup-help`,
            theme: getTooltipTheme('help'),
            placement: getTooltipPlacement('help'),
        });
    }
    handleHelpMouseLeave() {
        hide();
    }
    renderTooltipHelp() {
        const help = this.getDisplayProp('help');
        if (help) {
            return (React.createElement(Icon, { type: "help", onMouseEnter: this.handleHelpMouseEnter, onMouseLeave: this.handleHelpMouseLeave }));
        }
    }
    renderFloatLabel() {
        if (this.hasFloatLabel) {
            const label = this.getLabel();
            if (label) {
                const { labelTooltip, floatLabelOffsetX } = this;
                const prefixCls = this.getContextProPrefixCls(FIELD_SUFFIX);
                const required = this.getProp('required');
                const classString = classNames(`${prefixCls}-label`, {
                    [`${prefixCls}-required`]: required,
                    [`${prefixCls}-readonly`]: this.readOnly,
                });
                const style = floatLabelOffsetX ? {
                    marginLeft: floatLabelOffsetX,
                } : undefined;
                return (React.createElement("div", { className: `${prefixCls}-label-wrapper`, style: style },
                    React.createElement("div", { className: classString, title: isString(label) && !(labelTooltip && [TextTooltip.always, TextTooltip.overflow].includes(labelTooltip)) ? label : undefined, onMouseEnter: this.handleFloatLabelMouseEnter, onMouseLeave: this.handleFloatLabelMouseLeave }, label),
                    this.renderTooltipHelp()));
            }
        }
    }
    getOtherProps() {
        const otherProps = super.getOtherProps();
        otherProps.onFocus = noop;
        otherProps.onBlur = noop;
        return otherProps;
    }
    renderWrapper() {
        const value = this.getValue();
        return (React.createElement("label", Object.assign({ key: "wrapper" }, this.getWrapperProps()),
            this.renderFloatLabel(),
            React.createElement("div", { onMouseEnter: this.handleMouseEnter, onMouseLeave: this.handleMouseLeave },
                React.createElement(C7NRate, Object.assign({}, this.getOtherProps(), { onChange: this.onChange, value: value })))));
    }
    renderHelpMessage() {
        const label = this.getLabel();
        if (!this.hasFloatLabel || !label) {
            const help = this.getDisplayProp('help');
            if (help) {
                return (React.createElement("div", { key: "help", className: `${this.getContextProPrefixCls(FIELD_SUFFIX)}-help` }, help));
            }
        }
    }
};
Rate.displayName = 'Rate';
Rate.defaultProps = {
    ...C7NRate.defaultProps,
    ...FormField.defaultProps,
    suffixCls: 'rate',
};
// eslint-disable-next-line camelcase
Rate.__PRO_RATE = true;
// eslint-disable-next-line camelcase
Rate.__IS_IN_CELL_EDITOR = true;
__decorate([
    autobind
], Rate.prototype, "renderValidationResult", null);
__decorate([
    autobind
], Rate.prototype, "handleHelpMouseEnter", null);
Rate = __decorate([
    observer
], Rate);
export default Rate;
